import { Component, OnInit, Input } from '@angular/core';
import { Options } from './options';
@Component({
  selector: 'dsc-header',
  template: `
      <clr-header class="header header_dell_carbon">
          <div class="branding" style="padding: 0 2rem;">   
            <div>
            <dsc-collapsible-list [menuList]= "menuList" [windowPosition]="'left'" *ngIf="menuList"></dsc-collapsible-list>
              <a href="#" class="nav-link"> 
                <img alt="img" class="icon_size" src="{{options.url}}" width=40/>
                &nbsp;
                <span class="line"></span>
                <span class="title">{{options.title}}</span>
              </a>
            </div>
          </div>
          <div class="header-actions" style="padding: 0 2rem 0 1rem;">
            <div class="header-actions">
              <clr-dropdown>
                <button class="nav-text" clrDropdownTrigger>
                  <clr-icon shape="user"></clr-icon>
                   {{options.username}}
                  <!--<clr-icon shape="caret down"></clr-icon>-->
                </button>
              </clr-dropdown>
            </div>
          </div>
        </clr-header>
  `,
  styles: []
})
export class DscHeaderComponent implements OnInit {

  @Input('init')
  options: Options

  @Input('menu')
  menuList: []
  
  constructor() { }

  ngOnInit() {;
 
  }

}

